import React from 'react';
import HelpBadge from './components/HelpBadge';
import DodTermText from './DodTermText';
import {
  OFAC_PLAN_COVERAGE_COPY,
  ofacPlanCoverageText,
  type OfacLanguage,
} from './ofacPlanCoverageCopy';

type OfacPlanCoverageProps = {
  language: OfacLanguage;
  variant?: 'product' | 'subpage';
};

const OfacPlanCoverage: React.FC<OfacPlanCoverageProps> = ({
  language,
  variant = 'product',
}) => {
  const copy = OFAC_PLAN_COVERAGE_COPY;
  const headingId = 'ofac-plan-coverage-title';
  const compact = variant !== 'product';
  const seenTerms = new Set();

  return (
    <section
      className={`ofac-plan-coverage ofac-plan-coverage--${variant}${compact ? ' is-compact' : ''}`}
      aria-labelledby={headingId}
    >
      <header className="ofac-plan-coverage__header">
        <p className="ofac-plan-coverage__kicker">{ofacPlanCoverageText(language, copy.kicker)}</p>
        <h2 id={headingId} className="ofac-plan-coverage__title">
          <span>{ofacPlanCoverageText(language, copy.title)}</span>
          <HelpBadge
            label={language === 'es' ? 'Ayuda sobre cobertura por plan' : 'Help about coverage by plan'}
            wide
          >
            <p>{ofacPlanCoverageText(language, copy.help)}</p>
          </HelpBadge>
        </h2>
        <p>
          <DodTermText text={ofacPlanCoverageText(language, copy.lead)} language={language} seen={seenTerms} />
        </p>
      </header>
      <div className="ofac-plan-coverage__grid" aria-label={ofacPlanCoverageText(language, copy.kicker)}>
        {copy.plans.map((plan) => (
          <article key={plan.id} className={`ofac-plan-coverage__card is-${plan.id}`}>
            <h3>{ofacPlanCoverageText(language, plan.name)}</h3>
            <p className="ofac-plan-coverage__price">{ofacPlanCoverageText(language, plan.price)}</p>
            <p>
              <DodTermText text={ofacPlanCoverageText(language, plan.body)} language={language} seen={new Set()} />
            </p>
          </article>
        ))}
      </div>
      <p className="ofac-plan-coverage__disclaimer">{ofacPlanCoverageText(language, copy.disclaimer)}</p>
    </section>
  );
};

export default OfacPlanCoverage;
